import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {TabNavigation} from '@albert-io/atomic';

export default function IndiePracticeTab({curriculumArea, isActive, onClick}) {
  const id = curriculumArea.getId();
  return (
    <TabNavigation.Tab
      as='li'
      className='u-display_flex ip__tab'
      isActive={isActive}
      role='presentation'
    >
      <a
        className={classnames('u-text-decoration_none ip__tab__link u-pad-tb_3 u-pad-lr_2', {
          'u-color_blue-400': isActive,
          'ip__tab__link--inactive': !isActive
        })}
        aria-selected={isActive}
        href={`#section${id}`}
        id={id}
        onClick={onClick}
        role='tab'
      >
        {curriculumArea.getName()}
      </a>
    </TabNavigation.Tab>
  );
}

IndiePracticeTab.propTypes = {
  curriculumArea: PropTypes.shape({
    getId: PropTypes.func,
    getName: PropTypes.func
  }),
  isActive: PropTypes.bool,
  onClick: PropTypes.func
};
